import { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import InjectedStripeCheckoutForm from "../components/StripeCheckoutForm";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import { createPaymentIntentStripe } from "../apis/RangerOnlineApi";

const stripePromise = loadStripe(
  "pk_test_51LTWZMDpS83u5ucvxMJIvsgVQdoXgThM6Z3VURfIEhHf7UMSww4mv8L2iusQU295tCBQVsO2uD7pWwZ4G9nmS6GV00l96FGM2p"
);

export const StripePaymentDialog = (props) => {
  const { open, onClose, order } = props;
  const [clientSecret, setClientSecret] = useState("");

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
  };

  const getPaymentIntent = async (amount) => {
    const param = {
      amount: amount,
    };
    const response = await createPaymentIntentStripe(param);

    if (response?.status) {
      alert("an error occured");
      return;
    }

    setClientSecret(response.intentId);
  };

  useEffect(() => {
    getPaymentIntent(order.orderTotal);
  }, []);

  return (
    <>
      <Dialog open={open} onClose={() => onClose()} maxWidth={"sm"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            padding: 2,
          }}
        >
          <DialogContent dividers>
            {clientSecret && (
              <Elements options={options} stripe={stripePromise}>
                <InjectedStripeCheckoutForm order={order} onClose={onClose} />
              </Elements>
            )}
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
